// constants

const SET_TOTO_TOTAL = "SET_TOTO_TOTAL";
const ADD_TOTO_TOTAL = "ADD_TOTO_TOTAL";
const RESET_TOTO_TOTAL = "RESET_TOTO_TOTAL";

// reducers

const initialState = 0;

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_TOTO_TOTAL:
			if (action.payload < 0) return state;
			return action.payload;
		case ADD_TOTO_TOTAL:
			return state + action.payload;
		case RESET_TOTO_TOTAL:
			return 0;
		default:
			return state;
	}
};
export default Reducer;

// actions
export const setTotoTotal =
	(total = -1) =>
	async (dispatch) => {
		dispatch({
			type: SET_TOTO_TOTAL,
			payload: total,
		});
	};

export const addTotoTotal =
	(total = 0) =>
	async (dispatch) => {
		dispatch({
			type: ADD_TOTO_TOTAL,
			payload: total,
		});
	};

export const resetTotoTotal = () => async (dispatch) => {
	dispatch({
		type: RESET_TOTO_TOTAL,
	});
};
